import { render, staticRenderFns } from "./clean-ocean.vue?vue&type=template&id=369e38e4&scoped=true"
import script from "./clean-ocean.vue?vue&type=script&lang=js"
export * from "./clean-ocean.vue?vue&type=script&lang=js"
import style0 from "./clean-ocean.vue?vue&type=style&index=0&id=369e38e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369e38e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,ContactUsCard: require('/var/www/tubber-new/components/global/ContactUsCard.vue').default})
